// Config.
import Config 			 from './config/config.js';

// Misc dependencies.
import createActionTypes from '../../../factories/actionTypes.js';

/**
 * <pre>
 * Overlay module Action Types.
 *
 * Summary of responsibilities:
 *
 *  - defines Redux action types specific to component
 * </pre>
 *
 * @author Tim Loram
 *
 * @memberof module:Overlay
 * @namespace
 *
 * @type {Object}
 * @property {String} REGISTER_INSTANCE Dispatched before a new overlay instance is opened.
 * @property {String} OPEN Dispatched when a new overlay instance is opened (and before it is made visible).
 * @property {String} CLOSE Dispatched when an overlay instance is closed.
 * @property {String} CENTER Dispatched when an overlay instance needs centering.
 * @property {String} UPDATE_POSITION_MODE Dispatched when the positioning mode (absolute|static) needs changing based on the campaigns embed status.
 * @property {String} UPDATE_VISIBILITY Dispatched when an overlay instance is ready to be made visible (e.g after content has loaded and centering has taken place).
 */
const ActionTypes = {
	REGISTER_INSTANCE: 		'REGISTER_OVERLAY_INSTANCE',

	OPEN: 					'OPEN',
	CLOSE: 					'CLOSE',

	CENTER: 				'CENTER',

	UPDATE_POSITION_MODE: 	'UPDATE_POSITION_MODE',
	UPDATE_VISIBILITY: 	 	'UPDATE_VISIBILITY'
};

export default createActionTypes(ActionTypes, Config.stateKey);